"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastUpdatedFieldLogic = void 0;
var last_updated_fieldtype_1 = require("./last-updated.fieldtype");
Object.defineProperty(exports, "LastUpdatedFieldLogic", { enumerable: true, get: function () { return last_updated_fieldtype_1.LastUpdatedFieldLogic; } });
